import React, { useState } from 'react';
import { Button, Menu, Box, TextField } from '@material-ui/core';
import { StaticDatePicker } from '@material-ui/pickers';
import { format } from 'date-fns';
import {
  DateRange as IconDateRange,
  Done as IconDone,
  ArrowDropDown as IconArrowDropDown,
  Clear as IconClear
} from '@material-ui/icons';
import { formatMessage } from '../../i18n/translate';

type Props = {
  value?: Date | null;
  onChange: (date: Date | null) => void;
  minDate?: Date;
  maxDate?: Date;
};

const SingleDatePicker = ({ value = null, onChange, minDate, maxDate }: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [date, setDate] = useState<Date | null>(value);

  return (
    <>
      <Button variant="contained" onClick={e => setAnchorEl(e.currentTarget)}>
        <IconDateRange />
        <span style={{ marginLeft: 8 }}>{date ? format(date, 'dd/MM/yyyy') : '__/__/____'}</span>
        <IconArrowDropDown />
      </Button>

      <Menu open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={() => setAnchorEl(null)}>
        <Box p={2}>
          <StaticDatePicker
            value={date}
            onChange={newDate => setDate(newDate)}
            renderInput={props => <TextField {...props} />}
            displayStaticWrapperAs="desktop"
            minDate={minDate}
            maxDate={maxDate ?? new Date()}
          />

          <Box mt={2} display="flex" justifyContent="space-between">
            <Button
              startIcon={<IconClear />}
              onClick={() => {
                setDate(null);
                onChange(null);
                setAnchorEl(null);
              }}>
              {formatMessage('commonLabelClear')}
            </Button>

            <Button
              startIcon={<IconDone />}
              color="primary"
              variant="contained"
              onClick={() => {
                onChange(date);
                setAnchorEl(null);
              }}>
              {formatMessage('commonLabelSelect')}
            </Button>
          </Box>
        </Box>
      </Menu>
    </>
  );
};

export default SingleDatePicker;
